import getDB from './util/getDB';

export const offlineTaskExpirationDatesKeyVal = getDB<{
    expires: Date;
}>('OfflineTaskExpirationDates', 1, 'expirations');
